export const TextTableCell = ({ value }: { value: boolean }) => (
  <span>{value}</span>
);
